module.exports = __webpack_public_path__ + "img/ul-logo.348bf4da.png";